/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuPriceRanges_user$ref = any;
export type SbRespRefineMenuFilterPrice_user$ref = any;
export type SbRespRefineMenuFilterPrice_user = {
    readonly " $fragmentRefs": SbSharedRefineMenuPriceRanges_user$ref;
    readonly " $refType": SbRespRefineMenuFilterPrice_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterPrice_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuPriceRanges_user",
      "args": null
    }
  ]
};
(node as any).hash = 'd5d1849717150a9b7015e0a209e2f85a';
export default node;
